module.exports = __webpack_public_path__ + "static/media/select.c4230c4a.less";